import { createApp } from 'vue'
import VueProgressBar from "@aacassandra/vue3-progressbar";
import VueYandexMetrika from 'vue-yandex-metrika' 

import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

const options = {
  color: "#D63727",
  failedColor: "#000",
  thickness: "3px", 
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300
  },
  autoRevert: true,
  location: "top",
  inverse: false
}

axios.defaults.baseURL = 'https://xn--2024-f4dliahtc3d.xn--p1ai'

createApp(App).use(VueProgressBar, options).use(store).use(router, axios).mount('#app')

